import React, { useEffect, useState } from 'react';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Badge from '@material-ui/core/Badge';
import Avatar from '@material-ui/core/Avatar';

const useStyles = makeStyles((theme) => ({
  // container that had inline styles
  outerContainer: {
    marginTop: 16,
    marginBottom: 16,
    border: '1px solid rgba(233, 235, 245, 1)',
  },

  accordionRoot: {
    '&::before': { display: 'none' },
    borderRadius: '4px 4px 0 0 !important',
    border: '1px solid rgba(245, 245, 245, 1) !important',
    boxShadow: 'none',
    '&.Mui-expanded': { margin: '0px' },
  },

  commentAvatar: {
    height: 24,
    width: 24,
    fontSize: 11,
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: 'normal',
    backgroundColor: '#5398E6',
    color: '#fff',
  },

  badgePosition: {
    top: '-1px',
    right: '-1px',
    fontSize: '10px',
    height: '16px',
    minWidth: '16px',
    borderRadius: '50%',
  },

  expandedSummary: {
    '&::before': { backgroundColor: 'none' },
    '&.MuiAccordionSummary-root': { maxHeight: '55px', minHeight: '55px' },
    '&.Mui-expanded': { maxHeight: '55px', minHeight: '55px' },
    '& .MuiAccordionSummary-expandIcon': { marginRight: '30px !important' },
    '& .MuiAccordionSummary-expandIcon.Mui-expanded': { marginRight: '30px !important' },
    '& .MuiAccordionSummary-content.Mui-expanded': { margin: 0 },
  },

  // header text + icon row
  headerText: {
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 400,
    color: 'rgba(33, 33, 33, 1)',
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
  },
  headerIconImg: {
    display: 'block',
  },
  expandIcon: {
    color: 'rgba(33, 33, 33, 1)',
    height: 20,
    width: 20,
  },

  // comments list container inside details
  detailsInner: {},

  // each comment block container
  commentBlock: {
    display: 'flex',
    flexDirection: 'column',
    gap: 10,
    marginTop: 10,
  },

  // top row inside comment block
  topRow: {
    display: 'flex',
    justifyContent: 'start',
    alignItems: 'center',
    gap: 10,
  },
  avatarWrap: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  avatarIcon: {
    color: 'rgba(48, 164, 97, 1)',
    height: 24,
    width: 24,
  },
  nameTimeWrap: {
    display: 'flex',
    justifyContent: 'start',
    alignItems: 'baseline',
    gap: 4,
  },
  commenterName: {
    fontSize: 14,
    fontWeight: 400,
    color: 'rgba(33, 33, 33, 1)',
    lineHeight: 1,
  },
  commentTime: {
    fontSize: 12,
    fontWeight: 400,
    color: 'rgba(117, 117, 117, 1)',
    lineHeight: 1,
  },

  // bottom row inside comment block
  bottomRow: {
    display: 'flex',
    justifyContent: 'start',
    alignItems: 'center',
    gap: 10,
  },
  leftIndent: { width: 24 },
  bottomTextWrap: { flexGrow: 1 },
  commentText: {
    fontSize: 12,
    fontWeight: 400,
    color: 'rgba(33, 33, 33, 1)',
    lineHeight: 1.5,
  },

  // "No comments" text
  noCommentsText: {
    fontWeight: 400,
    fontSize: 12,
    color: 'rgba(120, 121, 142, 1)',
    textAlign: 'center',
  },

  // add comment area
  addCommentOuter: {
    width: '100%',
    marginTop: 10,
  },
  addCommentRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'start',
    gap: 10,
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      gap: 8,
    },
  },
  addCommentAvatar: {
    display: 'flex',
    justifyContent: 'start',
    alignItems: 'center',
  },
  addCommentAvatarIcon: {
    color: 'rgba(48, 164, 97, 1)',
    height: 24,
    width: 24,
  },
  addCommentRight: {
    width: '100%',
    paddingRight: 10,
    position: 'relative',
  },
  textarea: {
    width: '100%',
    height: 80,
    fontSize: 12,
    resize: 'none',
    outline: 'none',
    borderRadius: 4,
    border: '1px solid rgba(224, 224, 224, 1)',
    background: 'rgba(250, 250, 250, 1)',
    padding: '5px 8px 6px 8px',
    boxSizing: 'border-box',
    [theme.breakpoints.down('sm')]: {
      height: 70,
      fontSize: 11.5,
      padding: '5px 8px',
    },
  },
  addButton: {
    height: 26,
    padding: '3px 10px',
    color: 'rgba(255, 255, 255, 1)',
    borderRadius: 4,
    backgroundColor: 'rgba(2, 136, 209, 1)',
    position: 'absolute',
    top: 45,
    right: '2%',
    [theme.breakpoints.down('sm')]: {
      top: 50,
      padding: '3px 8px',
      height: 24,
    },
    '&:hover': {
      backgroundColor: 'rgba(2, 136, 209, 1)',
      borderColor: '#3F51B5',
      boxShadow: 'none',
    },
  },

}));

const CommentViewer = (props) => {
  const { blockState, loader, shouldDisableFields, block } = props;

  const classes = useStyles();
  const [comment, setComment] = useState("");

  const toCamelCase = (str) => str?.toLowerCase()?.replace(/[^a-zA-Z0-9]+(.)/g, (_, chr) => chr?.toUpperCase());

  const filteredComments = Array.isArray(blockState?.workflowComments)
    ? blockState.workflowComments.filter(c => c?.action === block.name)
    : [];


    console.log('filteredComments**CommentViewer', filteredComments, toCamelCase(blockState.status));

  const commentCount = filteredComments.length;

  useEffect(() => {
    if (props.formData?.document[props.data.chartUniqueId + '_Add_Comment_Obligation']) {
      setComment("");
      props.clearReduxDataOfCurrentComponent({
        key: 'document',
        subKey: [`${props.data.chartUniqueId}_Add_Comment_Obligation`]
      })
      props.fetchSingleObligation()
    }
  }, [props.formData?.document[props.data.chartUniqueId + '_Add_Comment_Obligation']])

  const getTimeAgo = (dateString) => {
    if (!dateString) return '';
    const now = new Date();
    const date = new Date(dateString);
    if (isNaN(date)) return '';
    const diffMs = now - date;
    const diffMinutes = Math.floor(diffMs / (1000 * 60));
    const diffHours = Math.floor(diffMinutes / 60);
    const diffDays = Math.floor(diffHours / 24);
    const diffWeeks = Math.floor(diffDays / 7);

    if (diffMinutes < 60) {
      return `${diffMinutes} minute${diffMinutes !== 1 ? 's' : ''} ago`;
    } else if (diffHours < 24) {
      return `${diffHours} hour${diffHours !== 1 ? 's' : ''} ago`;
    } else if (diffDays < 7) {
      return `${diffDays} day${diffDays !== 1 ? 's' : ''} ago`;
    } else {
      return `${diffWeeks}w`;
    }
  };

  const handleAddComment = () => {
    if (!comment.trim()) return;
    let payload = {
      appId: props.match.params.appid,
      orgId: props.appConfig?.org?._id,
      dataUniqueId: props.data.chartUniqueId + '_Add_Comment_Obligation',
      data: {
        dmId: props.data.chartData.selectedDataModel,
        docId: props.match.params.id,
        comment: comment,
      },
    }
    props.clearReduxDataOfCurrentComponent({
      key: 'document',
      subKey: [`${props.data.chartUniqueId}_getsingleobligation`]
    })
    props.addComment(payload)
  };

  const getInitials = (name) => {
    if (!name) return '?';
    return name
      .split(' ')
      .map(word => word.charAt(0))
      .join('')
      .toUpperCase()
      .slice(0, 2);
  };

  return (
    <div className={classes.outerContainer}>
      {
        <Accordion className={classes.accordionRoot}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon className={classes.expandIcon} />}
            aria-controls="panel1a-content"
            className={classes.expandedSummary}
            defaultExpanded={false}
            id="panel1a-header"
          >
            <Typography className={classes.headerText}>
              <img
                src={'/media/svg/replyComment.svg'}
                alt="replyComment"
                className={classes.headerIconImg}
              />
              Comment{commentCount > 0 ? ` (${commentCount})` : ""}
            </Typography>
          </AccordionSummary>

          <AccordionDetails>
            <div className={classes.detailsInner}>
              {
                blockState["workflow"] && (() => {
                  const comments = (blockState?.["workflowComments"] || [])
                    .filter(comment => comment?.action === block.name);

                  return comments.length > 0 ? (
                    comments.map((comment, index) => (
                      <div key={index} className={classes.commentBlock}>
                        {/* Top row: icon + name + time */}
                        <div className={classes.topRow}>
                          <div className={classes.avatarWrap}>
                            <Avatar className={classes.commentAvatar}>
                              {getInitials(comment?.by?.name)}
                            </Avatar>
                          </div>
                          <div className={classes.nameTimeWrap}>
                            <Typography className={classes.commenterName}>
                              {comment?.by?.name}
                            </Typography>
                            <Typography className={classes.commentTime}>
                              {getTimeAgo(comment?.datetime)}
                            </Typography>
                          </div>
                        </div>

                        {/* Bottom row: indented comment */}
                        <div className={classes.bottomRow}>
                          <div className={classes.leftIndent} />
                          <div className={classes.bottomTextWrap}>
                            <Typography className={classes.commentText}>
                              {comment?.comment}
                            </Typography>
                          </div>
                        </div>
                      </div>
                    ))
                  ) : (
                    <Typography className={classes.noCommentsText}>
                      No comments to show
                    </Typography>
                  );
                })()
              }
            </div>

            {
              !shouldDisableFields && blockState["workflow"] && (
                <div className={classes.addCommentOuter}>
                  <div className={classes.addCommentRow}>
                    <image className={classes.addCommentAvatar}>
                      {/* <AccountCircleIcon className={classes.addCommentAvatarIcon} /> */}
                      <Avatar className={classes.commentAvatar}>
                        {getInitials(props.members?.name)}
                      </Avatar>
                    </image>
                    <div className={classes.addCommentRight}>
                      <textarea
                        value={comment}
                        onChange={(e) => setComment(e.target.value)}
                        placeholder="Comment text here"
                        className={classes.textarea}
                      />
                      <Button
                        variant="contained"
                        className={classes.addButton}
                        onClick={handleAddComment}
                      >
                        Add Comment
                      </Button>
                    </div>
                  </div>
                </div>
              )
            }
          </AccordionDetails>
        </Accordion>
      }
    </div>
  )
}

export default CommentViewer
